import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { PhotoGallery } from './PhotoGallery';
import { VisitCTA } from './VisitCTA';
import { QuickLinks } from './QuickLinks';
export function PhotoTourPage() {
  return <PageLayout data-id="element-2468">
      <HeaderBanner data-id="element-2469" />
      <PhotoGallery data-id="element-2470" />
      <VisitCTA data-id="element-2471" />
      <QuickLinks data-id="element-2472" />
    </PageLayout>;
}